import Vue from 'vue'
// custom directives
Vue.directive('maxHeight', function (el, binding) {
  el.style.maxHeight = binding.value.height
  el.style.overflowY = 'scroll'
  el.style.overflowX = 'hidden'
})
Vue.directive('maxWidth', function (el, binding) {
  el.style.maxWidth = binding.value.width
})
